export const ENV = {
  ADMIN_APOLLO_CLIENT_URI: import.meta.env.VITE_ADMIN_APOLLO_CLIENT_URI ?? '',
  VIEWER_APOLLO_CLIENT_URI: import.meta.env.VITE_VIEWER_APOLLO_CLIENT_URI ?? '',
  AUTHENTICATION_KEYCLOAK_URI: import.meta.env.VITE_AUTHENTICATION_KEYCLOAK_URI ?? '',
  AUTHENTICATION_KEYCLOAK_CLIENT_ID: import.meta.env.VITE_AUTHENTICATION_KEYCLOAK_CLIENT_ID ?? '',
  AUTHENTICATION_KEYCLOAK_REALM: import.meta.env.VITE_AUTHENTICATION_KEYCLOAK_REALM ?? '',
  VIDEO_ENDPOINT: import.meta.env.VITE_VIDEO_ENDPOINT ?? '',
  VMRPO_KEYCLOAK_URI: import.meta.env.VITE_VMRPO_KEYCLOAK_URI ?? '',
  SSO_KEYCLOAK_URI: import.meta.env.VITE_SSO_KEYCLOAK_URI ?? '',
  SSO_KEYCLOAK_TOKEN_URI: import.meta.env.VITE_SSO_KEYCLOAK_TOKEN_URI ?? '',
  YOUBORA_ACCOUNT_CODE: import.meta.env.VITE_YOUBORA_ACCOUNT_CODE ?? '',
  YOUBORA_HOST: import.meta.env.VITE_YOUBORA_HOST ?? '',
  MODE: import.meta.env.VITE_MODE ?? '',
  SUBFOLDER_PATH: import.meta.env.VITE_SUBFOLDER_PATH ?? '',
  NEW_RELIC_APP_ID: import.meta.env.VITE_NEW_RELIC_APP_ID ?? '',
  NEW_RELIC_LICENSE_KEY: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY ?? '',
  NEW_RELIC_JS_AGENT_URL: import.meta.env.VITE_NEW_RELIC_JS_AGENT_URL ?? '',
  NEW_RELIC_JS_BEACON_URL: import.meta.env.VITE_NEW_RELIC_JS_BEACON_URL ?? '',
};
